import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SERVICES } from "@/data/content";

export default function ServicesGrid({ variant = "cards" }) {
  if (variant === "rows") {
    return (
      <div data-testid="services-rows" className="border-y border-oxford/10 divide-y divide-oxford/10">
        {SERVICES.map((s, i) => (
          <Reveal key={s.title} delay={Math.min(i * 0.04, 0.3)}>
            <div className="group relative grid md:grid-cols-12 gap-3 md:gap-6 items-start md:items-center py-7 lg:py-8 px-2 md:px-6 transition-colors duration-300 hover:bg-bone">
              <span className="absolute left-0 top-0 h-full w-[2px] bg-gold scale-y-0 group-hover:scale-y-100 transition-transform duration-300 origin-top" />
              <span className="md:col-span-1 font-display text-sm font-semibold text-gold/80">{String(i + 1).padStart(2, "0")}</span>
              <div className="md:col-span-4 flex items-center gap-4">
                <s.icon className="h-5 w-5 text-gold shrink-0" strokeWidth={1.5} />
                <h3 className="font-display text-lg font-semibold text-oxford">{s.title}</h3>
              </div>
              <p className="md:col-span-6 text-sm leading-relaxed text-carbon/70">{s.desc}</p>
              <ArrowUpRight className="hidden md:block md:col-span-1 justify-self-end h-5 w-5 text-steel/50 transition-all duration-300 group-hover:text-gold group-hover:translate-x-1 group-hover:-translate-y-1" />
            </div>
          </Reveal>
        ))}
      </div>
    );
  }

  return (
    <div data-testid="services-grid" className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-oxford/10 border border-oxford/10">
      {SERVICES.map((s, i) => (
        <Reveal key={s.title} delay={Math.min(i * 0.04, 0.3)} className="h-full">
          <Link
            to="/servicios"
            data-testid={`service-card-${i + 1}`}
            className="group relative flex flex-col h-full bg-white p-8 lg:p-9 transition-all duration-300 hover:-translate-y-1 hover:bg-bone hover:shadow-[0_24px_50px_-24px_rgba(5,19,35,0.25)]"
          >
            <span className="absolute top-0 left-0 h-[2px] w-0 bg-gold transition-all duration-500 group-hover:w-full" />
            <span className="absolute top-5 right-6 font-display text-4xl font-bold text-oxford/[0.06] select-none">{String(i + 1).padStart(2, "0")}</span>
            <s.icon className="h-6 w-6 text-gold" strokeWidth={1.5} />
            <h3 className="mt-6 font-display text-base font-semibold uppercase tracking-wide text-oxford">{s.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-carbon/70">{s.desc}</p>
          </Link>
        </Reveal>
      ))}
    </div>
  );
}
